import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/auth";

export default function AdminPanelLayout({ component }) {

  const { token, authorizeUserData } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const authorizeUser = async () => {
    try {
      const response = await fetch("https://hotelbnb-backend.onrender.com/authorize", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const result = await response.json();
        if(result.is_Admin){
          return;
        }
      }
      return navigate("/login");

    } catch (error) {
      console.log(error);
      navigate("/login");
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    authorizeUser();
  }, []);


  const adminSideNavigationOpen = useRef("");

  const adminSideNavigationOpenHandler = () => {
    adminSideNavigationOpen.current.classList.toggle(
      "admin-side-navigation-open"
    );
  };

  if(!loading) return (
    <>
      {/* NavBar Start */}
      <div className="container-fluid admin-navBar">
        <div className="row align-items-center">
          {/* Logo Start */}
          <div className="col-auto logo">
            <Link to="/">Hotelbnb</Link>
          </div>
          {/* Logo End */}

          {/* Admin Profile and Hamburger Menu Start */}
          <div className="col-auto ms-auto accountDetails d-flex justify-content-center align-items-center">
            {/* Image */}
            <img src={authorizeUserData?.user_img} alt="admin-profile" />
            {/* Details */}
            <Link to="/admin/admin-profile" className="details text-decoration-none">
              <p className="p-0 m-0 name fw-medium text-capitalize">{authorizeUserData?.user_first_name} {authorizeUserData?.user_last_name}</p>
              <p className="p-0 m-0 role">Superadmin</p>
            </Link>
            {/* Hamburger */}
            <div
              className="ms-sm-3 ms-2 d-lg-none navbar-toggler"
              onClick={adminSideNavigationOpenHandler}
            >
              <i className="fa-solid fa-bars custom-navbar-toggler-icon"></i>
            </div>
          </div>
          {/* Admin Profile and Hamburger Menu End */}
        </div>
      </div>
      {/* NavBar End */}

      {/* Admin Panel Body Start */}
      <div className="container-fluid p-0 admin-panel-content-body">
        <div className="row p-0 m-0 d-flex h-100">
          {/* Side Navigation Start */}
          <div className="admin-side-navigation" ref={adminSideNavigationOpen}>
            <ul className="p-0 m-0 d-flex flex-column">
              <NavLink to="/admin/dashboard" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/dashboard.png" alt="Dashboard" />
                <span>Dashboard</span>
              </NavLink>
              <NavLink to="/admin/admin-profile" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/account.png" alt="Profile" />
                <span>Profile</span>
              </NavLink>
              <NavLink to="/admin/add-places" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/city.png" alt="Places" />
                <span>Places</span>
              </NavLink>
              <NavLink to="/admin/add-hotels" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/hotel.png" alt="Hotels" />
                <span>Hotels</span>
              </NavLink>
              <NavLink to="/admin/add-rooms" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/room.png" alt="Rooms" />
                <span>Rooms</span>
              </NavLink>
              <NavLink to="/admin/all-bookings" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/bookings.png" alt="Bookings" />
                <span>All Bookings</span>
              </NavLink>
              <NavLink to="/admin/all-users" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/allUsers.png" alt="Users" />
                <span>All Users</span>
              </NavLink>
              <NavLink to="/admin/feedbacks" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/feedbacks.png" alt="Users" />
                <span>Feedbacks</span>
              </NavLink>
              <NavLink to="/admin/queries" className="d-flex justify-content-start align-items-center">
                <img src="/images/icons/queries.png" style={{width : "21px",}} alt="Users" />
                <span>All Queries</span>
              </NavLink>
            </ul>
          </div>
          {/* Side Navigation End */}

          {/* Admin Panel Content Area Start */}
          <div className="admin-panel-content-area">
            {/* -----Start----- */}
            {component}
            {/* -----End----- */}
          </div>
          {/* Admin Panel Content Area End */}
        </div>
      </div>
      {/* Admin Panel Body End */}
    </>
  );
}
